<template>
  <div class="item">
    <div
      class="item-c"
      @mouseenter="onMouseenter"
    >
      <img
        :src="handleImageUrl(itemData.materialType)"
      >
      <div class="item-content">
        <div class="item-content-title">
          {{ itemData.title }}.{{ itemData.fileSuffix }}
        </div>
      </div><div
        class="status-tips"
        :class="{'active': itemData.status === 1}"
      >
        {{ itemData.status === 1 ? '已发布' : itemData.status === 0 ? '未发布' : '已下线' }}
      </div>
      <div class="item-handle">
        <template v-if="itemData.status === 0">
          <div
            class="delete"
            @click="deleteClick"
          >
            删除
          </div>
          <div
            class="setting"
            @click="setting"
          >
            设置
          </div>
          <div
            class="publish"
            @click="publishClick"
          >
            发布
          </div>
        </template>
        <template v-else-if="itemData.status === 1">
          <div
            class="delete"
            @click="setting"
          >
            设置
          </div>
          <div
            class="setting"
            @click="offlineClick"
          >
            下线
          </div>
        </template>
        <template v-else>
          <div
            class="delete"
            @click="setting"
          >
            设置
          </div>
          <div
            class="reset-publish"
            @click="resetPublishClick"
          >
            重新发布
          </div>
        </template>
      </div>
      <div
        v-if="itemData.status === 1"
        class="statistics"
      >
        <span>浏览人数：{{ statistics.uv }}</span>
        <span class="second">浏览次数：{{ statistics.pv }}</span>
      </div>
      <mk-dialog-confirm
        :visible.sync="isShowConfirmDialog"
        v-bind="confirmDialogData"
        append-to-body
        @on-confirm="onConfirm"
      />
      <set-tag-drawer
        :visible.sync="isShowSetTagDialog"
        :dialog-data="setTagDialogData"
        @on-confirm="tagDialogConfirmFun"
      />
    </div>
    <div class="tag">
      <tag-list-show
        :tag-list="itemData.showTags"
        :limit="3"
      />
    </div>
  </div>
</template>
<script>
import setTagDrawer from './set-tag-drawer'
import tagListShow from '@components/tag-list-show'
export default {
  components: {
    setTagDrawer,
    tagListShow
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {
        }
      }
    },
    otherApi: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      handleType: '',
      isShowConfirmDialog: false,
      confirmDialogData: {
        title: '',
        tip: ''
      },
      isShowSetTagDialog: false,
      setTagDialogData: {},
      statistics: {
        pv: 0,
        uv: 0
      }
    }
  },
  computed: {
    tagList () {
      if (Array.isArray(this.itemData.showTags)) {
        return this.itemData.showTags.filter(item => {
          return item.name
        })
      } else return []
    }
  },
  created () {
    this.setTagDialogData = this.itemData
    const { rules, showTags } = this._.cloneDeep(this.itemData)
    this.util.rulesTagRemoveForbidden(rules, showTags)
    this.setTagDialogData.rules = rules
  },
  methods: {
    onMouseenter () {
      if (this.itemData.status === 1) {
        this.statisticsApi()
      }
    },
    /**
     * * 调用接口，获取pv、uv
     */
    async statisticsApi () {
      const res = await this.otherApi.statistics(
        {
          _id: this.itemData._id
        }
      )
      if (res.success) {
        this.statistics = res.data
      }
    },
    setting () {
      this.isShowSetTagDialog = true
    },
    handleImageUrl (val) {
      switch (val) {
        case 1:
          // 文档
          return require('@/assets/images/word.png')
        case 2:
          // 表格
          return require('@/assets/images/xlsx.png')
        case 3:
          // pdf
          return require('@/assets/images/pdf.png')
        case 5:
          // 幻灯片
          return require('@/assets/images/ppt.png')
        case 6:
          // 幻灯片
          return require('@/assets/images/image.png')
        case 7:
          // 音频
          return require('@/assets/images/mp3.png')
        case 8:
          // 音频
          return require('@/assets/images/video.png')
        default:
          break
      }
    },
    async tagDialogConfirmFun (data) {
      const res = await this.otherApi.update({
        ...this.itemData,
        title: data.title,
        rules: this.setTagDialogData.rules
      })
      if (res.success) {
        this.isShowSetTagDialog = false
        this.$message({
          type: 'success',
          message: '修改成功！'
        })
        // 【更新标签】成功，调用父组件的update-item
        this.$emit('update-item', { _id: this.itemData._id })
      }
    },
    deleteClick () {
      this.isShowConfirmDialog = true
      this.handleType = 'delete'
      this.confirmDialogData = {
        title: '确认要删除此内容吗',
        tip: '删除后无法恢复，是否删除？'
      }
    },
    // 下线
    offlineClick () {
      this.isShowConfirmDialog = true
      this.handleType = 'offline'
      this.confirmDialogData = {
        title: '确认要下线此内容吗？',
        tip: '下线后此内容无法访问'
      }
    },
    publishClick () {
      this.isShowConfirmDialog = true
      this.handleType = 'publish'
      this.confirmDialogData = {
        title: '确定要发布这条信息吗？',
        tip: '该作品尚未发布，发布后可进行分享，是否发布？',
        iconClass: 'guanbihuojingshihuocuowu',
        closeBtn: {
          type: 'default',
          color: '#595959',
          text: '取 消',
          isShow: true
        },
        confirmBtn: {
          type: 'primary',
          color: '#fff',
          text: '发 布',
          isShow: true
        }
      }
    },
    resetPublishClick () {
      this.isShowConfirmDialog = true
      this.handleType = 'publish'
      this.confirmDialogData = {
        title: '确定要重新发布这条信息吗？',
        tip: '该作品尚未发布，发布后可进行分享，是否发布？',
        iconClass: 'guanbihuojingshihuocuowu',
        closeBtn: {
          type: 'default',
          color: '#595959',
          text: '取 消',
          isShow: true
        },
        confirmBtn: {
          type: 'primary',
          color: '#fff',
          text: '发 布',
          isShow: true
        }
      }
    },
    onConfirm () {
      switch (this.handleType) {
        case 'delete':
          this.deleteItem()
          break
        case 'offline':
          this.offlineItem()
          break
        case 'publish':
          this.publishItem()
          break
        case 'reset-publish':
          this.publishItem()
          break
        default:
          break
      }
    },
    async deleteItem () {
      const res = await this.otherApi['delete']({
        _id: this.itemData._id
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '删除成功',
          showClose: true
        })
        this.isShowConfirmDialog = false
        this.$emit('delete-item')
      }
    },
    async offlineItem () {
      const res = await this.otherApi['update']({
        ...this.itemData,
        status: 2
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '下线成功',
          showClose: true
        })
        this.isShowConfirmDialog = false
        this.$emit('update-item', { status: 2 })
      }
    },
    async publishItem () {
      const res = await this.otherApi['update']({
        ...this.itemData,
        status: 1
      })
      if (res.success) {
        this.$message({
          type: 'success',
          message: '发布成功',
          showClose: true
        })
        this.isShowConfirmDialog = false
        this.$emit('update-item', { status: 1 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  width: 278px;
  // height: 173px;
  height: 152px;
  box-sizing: border-box;
  flex-shrink: 0;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  position: relative;
  cursor: pointer;

  .item-c {
    padding: 20px;
    display: flex;
    position: relative;

    img {
      display: block;
      width: 70px;
      height: 70px;
      flex-shrink: 0;
    }

    .item-content {
      width: 128px;
      word-wrap: break-word;
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .item-content-title {
        font-size: 14px;
        color: #262626;
        line-height: 20px;
        font-weight: 500;
        margin-top: 8px;
      }
    }

    .item-handle {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);

      .delete,
      .setting {
        display: inline-block;
        line-height: 24px;
        padding: 0 6px;
        color: #fff;
        border-radius: 2px;
        border: 1px solid #fff;
        margin: 8px;
        font-size: 13px;

        &:hover {
          background-color: #009cff;
          color: #fff;
          border-color: #009cff;
        }
      }

      .publish,
      .reset-publish {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 110px;
        line-height: 32px;
        border-radius: 16px;
        color: #fff;
        text-align: center;
        font-size: 14px;
        border: 1px solid #fff;
        background-color: rgba(254, 254, 254, 0.2);

        &:hover {
          background-color: #009cff;
          color: #fff;
          border-color: #009cff;
        }
      }
    }

    .status-tips {
      display: block;
      flex-shrink: 0;
      width: 64px;
      height: 28px;
      border-radius: 0 0 0 28px;
      background-color: #8c8c8c;
      color: #fff;
      font-size: 13px;
      text-align: center;
      line-height: 28px;
      position: absolute;
      top: 0;
      right: 0;
      text-indent: 8px;
    }

    .status-tips.active {
      background-color: #60c22f;
    }

    .statistics {
      position: absolute;
      bottom: 16px;
      font-size: 12px;
      line-height: 22px;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      text-align: center;
      color: #fff;
      display: none;

      .second {
        margin-left: 8px;
      }
    }

    &:hover {
      .item-handle,
      .statistics {
        display: block;
      }
    }
  }

  .tag {
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    padding: 0 20px;
    border-top: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
  }
}
</style>
<style lang="scss">
.tag-popper {
  min-width: unset;
  padding: 10px 0 0 10px;

  .tag-item-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 145px;
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(193, 193, 193, 0.8);
    }

    .tag-item {
      height: 22px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 10px;
      line-height: 22px;
      background-color: #ebeff4;
      color: #6b7b88;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
